import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/js/dist/modal'
import 'bootstrap/js/dist/dropdown'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faPlay,
  faPause,
  faStop,
  faAnalytics,
  faCog
} from '@fortawesome/pro-solid-svg-icons'
import {
  faPlusCircle,
  faFileAlt,
  faExternalLink,
  faMap,
  faRepeat,
  faTrash,
  faTerminal,
  faTimes,
  faShuttlecock
} from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import cookie from './plugins/cookie'

library.add(
  ...[
    faPlay,
    faPause,
    faStop,
    faPlusCircle,
    faFileAlt,
    faExternalLink,
    faMap,
    faRepeat,
    faAnalytics,
    faTrash,
    faTerminal,
    faTimes,
    faCog,
    faShuttlecock
  ]
)

createApp(App)
  .use(cookie)
  .component('font-awesome-icon', FontAwesomeIcon)
  .use(router)
  .mount('#app')
